import { useEffect, useState } from "react";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import firebaseApp from "./firebase";

const useFcmToken = (role) => {
  const [token, setToken] = useState("");
  const [notificationPermissionStatus, setNotificationPermissionStatus] =
    useState("");
  const [loading, setLoading] = useState(true);

  const browserSupported = async () => {
    const supported = await isSupported();
    return supported;
  };

  useEffect(() => {
    const retrieveToken = async () => {
      try {
        if (typeof window !== "undefined" && "serviceWorker" in navigator) {
          (async () => {
            const isSupport = await browserSupported();

            if (isSupport) {
              const messaging = getMessaging(firebaseApp);

              // Retrieve current permission status
              let permission = typeof Notification !== "undefined" ? Notification.permission : "default";
              
              // Only auto-request permission for STORE accounts. 
              // For doctors/admins, let them click the button if they want it.
              if (permission === "default" && role === "store") {
                permission = await Notification.requestPermission();
              }
              
              setNotificationPermissionStatus(permission);
              // Check if permission is granted before retrieving the token
              if (permission === "granted") {
                localStorage.setItem("notification", "yes");
                const currentToken = await getToken(messaging);

                if (currentToken) {
                  setToken(currentToken);
                } else {
                  console.error(
                    "No registration token available. Request permission to generate one."
                  );
                }
                setLoading(false);
              } else {
                localStorage.setItem("notification", "no");
                setLoading(false);
              }
            } else {
              localStorage.setItem("notification", "no");
              setLoading(false);
            }
          })().catch((err) => {
            localStorage.setItem("notification", "no");
            setLoading(false);
            console.error(err);
          });
        } else {
          localStorage.setItem("notification", "no");
          setLoading(false);
        }
      } catch (error) {
        localStorage.setItem("notification", "no");
        setLoading(false);
        console.error("An error occurred while retrieving token:", error);
      }
    };

    retrieveToken();
  }, [role]);

  return { fcmToken: token, notificationPermissionStatus, loading };
};

export default useFcmToken;
